import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { resultLevers } from '@/mocks/strategix';

export default function HowWeGetResults() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Как мы делаем результат"
          title="Не просто «крутим рекламу», а строим систему роста"
          description="Каждый рычаг работает на одну цель — стабильный рост подписчиков, охватов и заявок с прозрачной аналитикой."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {resultLevers.map((lever, index) => (
            <Reveal key={lever.title} delay={index * 80} className="h-full">
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-accent-400/60 transition-colors">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                  <i className={`${lever.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{lever.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{lever.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}